import { styled } from '@mui/material'

import { BaseContainer, BaseItem } from '../../configs/styles/BaseGrid'

export const DialogButtons = styled(BaseContainer)``

export const DialogContent = styled(BaseContainer)`
  &.MuiGrid-container {
    ${props => props.theme.breakpoints.only('sm')} {
      padding: 32px 16px;
    }

    ${props => props.theme.breakpoints.only('xs')} {
      padding: 32px 0;
    }
  }
`

export const DialogForm = styled(BaseContainer)``

export const DialogMessage = styled(BaseContainer)`
  &.MuiGrid-container {
    text-align: center;
  }
`

export const ErrorMessage = styled(BaseContainer)`
  &.MuiGrid-container {
    color: ${props => props.theme.palette.red[50]};
    font-size: 14px;
    text-align: center;
  }
`

export const Item = styled(BaseItem)`
  &.calendar__icon {
    .MuiInputBase-root {
      .MuiSvgIcon-root {
        height: 100%;
        padding: 0 6px;
      }

      &.Mui-disabled {
        > div {
          cursor: not-allowed;
          pointer-events: none;
          user-select: none;
        }
      }
    }
  }
`
